import { GameVars } from "./../../GameVars";
import { GameConstants } from "../../GameConstants";

export class Table extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.scaleX = GameVars.scaleX;

        let tableScale = 1 / Math.pow(GameVars.scaleX, 4);

        if (GameVars.scaleX > 1) {
            tableScale = 1 / Math.pow(GameVars.scaleX, 5);
        } 

        const tile = this.scene.add.image(0, 0, "texture_atlas_1", "table_tile.png");
        tile.scaleX = tableScale;
        this.add(tile);

        const leftCorner = this.scene.add.image(0, 0, "texture_atlas_1", "table_border.png");
        leftCorner.setOrigin(1, .5);
        leftCorner.x = tile.x - (tile.width * tile.scaleX) / 2;
        this.add(leftCorner);

        const rightCorner = this.scene.add.image(0, 0, "texture_atlas_1", "table_border.png");
        rightCorner.setOrigin(1, .5);
        rightCorner.scaleX = -1;
        rightCorner.x = tile.x + (tile.width * tile.scaleX) / 2;
        this.add(rightCorner);
    }
}
